<template>
  <div>
    <b-form @submit.prevent="submit" novalidate>
      <div class="row">
        <div class="col-12">
          <div class="data-list">
            <dl>
              <dt>Arve saaja</dt>
              <dd class="h5 mt-1">{{invoice.client.name}}</dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="data-list">
            <dl>
              <dt>Vahendatav riigimaks</dt>
              <dd class="h5 mt-1">{{invoice.declarationsTaxesTotalPrice | amountWithCurrency}}</dd>
            </dl>
          </div>
        </div>
        <div class="col-6">
          <div class="data-list">
            <dl>
              <dt>Tasuda</dt>
              <dd class="h5 mt-1">{{invoice.totalPrice | amountWithCurrency}}</dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="row border-top mt-2 pt-2">
        <div class="col-6">
          <validated-form-input name="dueDays" label="Maksetähtaeg päevades:" placeholder="Maksetähtaeg päevades" :disabled="dueDaysReadonly"
                                v-model.number="dueDays" validate="required|numeric|max_value:99" :validator="$validator"/>
        </div>
        <div class="col-6">
          <label>Arve kuupäev</label>
          <div class="input-group input-group-prepend-icon input-group-append-icon">
            <span class="input-group-prependable-icon mdi mdi-calendar"></span>
             <validated-form-input :datepicker="!invoiceDateReadonly" :disabled="invoiceDateReadonly" :min-days="-10" :max-days="0" name="invoiceDate" placeholder="Kinnitamise kuupäev"
                                   v-model="invoiceDate" validate="required|minDays:-10|maxDays:0" :validator="$validator"/>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <submit-button class="float-right" variant="success" :disabled="submitting"><i class="mdi mdi-check mr-1"></i>Kinnitan</submit-button>
        </div>
      </div>
    </b-form>
  </div>

</template>

<script>
  import ValidatedFormInput from '@/components/ValidatedFormInput'
  import gateway from '@/services/gateway'
  import moment from 'moment'

  export default {
    props: ['invoice', 'dueDaysReadonly', 'invoiceDateReadonly'],
    components: {ValidatedFormInput},
    data() {
      return {
        dueDays: this.invoice.paymentDueDays,
        invoiceDate: this.invoiceDateReadonly ? moment().format('DD.MM.YYYY') : null,
        submitting: false
      }
    },
    methods: {
      submit() {
        this.$validator.validateAll().then((valid) => {
          if (!valid) return
          this.submitting = true
          gateway.post(`/invoices/${this.invoice.id}/confirm`, {invoiceDate: this.invoiceDate, dueDays: this.dueDays})
            .then(() => this.$emit('done'))
            .catch(r => {
              this.$notifications.error(r.response.data.key ? this.$t(r.response.data.key) : 'Arve kinnitamine ebaõnnestus')
              this.submitting = false
            })
        })
      },
    }
  }
</script>
